import React from 'react';
import ReactDOM from 'react-dom';
import ReactNotification from 'react-notifications-component';

import './styles/index.tailwind.css';
import './styles/fonts.css';
import 'react-notifications-component/dist/theme.css';

import './i18n';
import { App } from './components/App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <ReactNotification className={'z-50'} />
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
